// Client de `GET /backoffice/stores/table` y de la ficha `GET /backoffice/stores/{id}/detail`.
import { ApiError } from '../../../errors';
import { apiFetch } from '../../../client';
import type {
    StoreDetailResponse,
    StoresTableApi,
    StoresTableResponse,
} from './storesTableContract';

const BASE_URL = import.meta.env.VITE_API_RETAIL_WIZARD_BASE_URL;

/** Una respuesta con otra forma se trata como ruta ausente, para que la pantalla use el respaldo. */
function missingRoute(what: string): ApiError {
    return new ApiError(404, { code: '', date: '', msg: `${what} no existe aún.` });
}

export const storesTableClient: StoresTableApi = {
    async getTable({ from, to }) {
        const params = new URLSearchParams({ from, to });
        // Sin refresh: mientras la ruta no exista, API Gateway responde 403 sin `code` y el refresh
        // cerraría la sesión. La pantalla trata ese 403 como «endpoint ausente».
        const page = await apiFetch<Partial<StoresTableResponse>>(
            `/backoffice/stores/table?${params.toString()}`,
            { baseUrl: BASE_URL, skipRefresh: true },
        );
        if (!page.sources || !Array.isArray(page.items)) throw missingRoute('La tabla de tiendas');
        return page as StoresTableResponse;
    },
    async getDetail(storeId, { from, to }) {
        const params = new URLSearchParams({ from, to });
        const detail = await apiFetch<Partial<StoreDetailResponse>>(
            `/backoffice/stores/${encodeURIComponent(storeId)}/detail?${params.toString()}`,
            { baseUrl: BASE_URL, skipRefresh: true },
        );
        if (!Array.isArray(detail.weeklyPlacement) || !Array.isArray(detail.categoryMix)) {
            throw missingRoute('La ficha de la tienda');
        }
        return detail as StoreDetailResponse;
    },
};
